/**
 * defa.views.InvitationView
 * Gives the user the choice to approve or reject an invitation.
 * @version 1.0.0
 */
import InvitationSubscriptions from 'scripts/defa/invitations/subscriptions/collection-invitation-subscriptions';
import InvitationSubscriptionCollectionView
							   from 'scripts/defa/invitations/subscriptions/view-invitation-subscription-collection-view';
import View                    from 'scripts/poppet/view';
import template                from 'templates/invitationView.jst.html';

const selectors = {
	region  : '[data-region=invitation-subscriptions-container]'
};

const InvitationView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	regions : {
		container: selectors.region,
	},
	
	templateContext: function () {
		return {
			owner: this.model.get( 'owner' ).name,
		};
	},
	
	onRender: function () {
		this._showSubscriptions();
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	/**
	 * Attaches the invitationSubscriptions collection view.
	 * @void
	 */
	_showSubscriptions: function () {
		let self = this;
		let invitationSubscriptionsCollectionView = new InvitationSubscriptionCollectionView( _.extend( this.options, {
			collection: new InvitationSubscriptions( self.model.get( 'subscriptions' ) )
		} ) );
		this.showChildView( 'container', invitationSubscriptionsCollectionView );
	}
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default InvitationView;
